import {useState} from "react";
import {findInputError, InputError, isFormInvalid} from "../../utils";
import {useFormContext} from "react-hook-form";
import {Dialog, DialogContent, TextField} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import forge from 'node-forge';

export default function CompanyField({
                                         lable,
                                         value,
                                         name,
                                         validation,
                                         base64String,
                                         companyName,
                                         transactionStatus
}) {

    const [activeBtn, setActiveBtn] = useState('activeGreenBtn')

    const {register, formState: {errors}} = useFormContext()
    const inputError = findInputError(errors, name)
    const isInvalid = isFormInvalid(inputError)

    const handleDownload = () => {
        const imageSrc = `data:image/png;base64,${base64String}`
        const link = document.createElement('a');
        link.href = imageSrc;
        link.download = name + "_" + companyName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return(
        <>

            <div className={`row w-100 ${transactionStatus === "REJECTED" || transactionStatus === "CHECKING_COMPANY_INFO" ? "justify-content-between" : "justify-content-center"} ps-3 mt-3`}>

                <div
                    className={`col-10 ${activeBtn === "activeRedBtn" ? "CompanyFieldError" : "CompanyFieldBorder"}  d-flex 
                    justify-content-between align-items-center`}
                    style={{fontSize: "0.9rem", padding: "13px 10px"}}
                >
                    <p className={`m-0 row-detail-span`}>{lable}</p>
                    {value && <p className={`m-0`}>{value}</p>}

                    {base64String && <p
                        className={`m-0 text-center pointer`}
                        style={{color: "#38bac4"}}
                        onClick={handleDownload}
                    >جهت دانلود تصویر کلیک کنید</p>}

                </div>

                {(transactionStatus === "REJECTED" || transactionStatus === "CHECKING_COMPANY_INFO") && <div className={`col-2 p-0 pe-3 d-flex align-items-center`}>
                    <div className={` btn-group ltr CompanyFieldBorder w-100`}>
                        <button
                            className={`btn btnLeaderCompanyField rounded py-2 px-0 ${activeBtn === 'activeGreenBtn' ? activeBtn : ''}`}
                            onClick={() => setActiveBtn('activeGreenBtn')}
                        >تایید
                        </button>

                        <button
                            className={`btn btnLeaderCompanyField rounded p-2 ${activeBtn === 'activeRedBtn' ? activeBtn : ''}`}
                            onClick={() => setActiveBtn('activeRedBtn')}
                        >رد
                        </button>
                    </div>

                </div>}

                <div className={`col-12 divTest flex-column mt-3 p-0
                 ${activeBtn === 'activeGreenBtn' ? 'notShow' : 'showError'}`}>

                    <label className="form-label text-form-title"
                    > دلیل رد {lable}</label>
                    <input
                        className={`form-control p-2 input-leader`}
                        placeholder={'لطفا دلیل رد درخواست را بنویسید.'}
                        name={name}
                        {...(activeBtn === 'activeGreenBtn' ? {} : register(name, validation)) }
                    />
                    {isInvalid && <InputError
                        show={isInvalid}
                        message={inputError?.error?.message}
                        key={inputError?.error?.message}
                    />}
                </div>

            </div>
        </>
    )
}

export function Modal({base64String, openModal, setOpenModal}) {


    const Base64Image = ({ base64String}) => {
        const imageSrc = `data:image/png;base64,${base64String}`
        return <img width={500} height={500} src={imageSrc}/>
    }

    return(

        <>
            <Dialog open={openModal}>
                <DialogContent>
                    <Grid2 justifyContent="center" spacing={1}>
                        <Grid2 xs={12} lg={12}>
                            <Base64Image base64String={base64String} />
                        </Grid2>

                        <Grid2 md={7} xs={12} textAlign="center">
                            <div className='text-center d-flex mt-3'>
                                <button
                                    className='btn border text-form-title ms-2 w-100'
                                    style={{"padding": "1.5% 13%"}}
                                    onClick={() => setOpenModal(false)}
                                >بستن
                                </button>

                            </div>

                        </Grid2>
                    </Grid2>
                </DialogContent>

            </Dialog>
        </>

    )
}
